import React from "react";
import locales from "./locales/pl";

const validate = (value, validations) => {
  let errors = [];

  if (validations.required) {
    if (value === null || value === undefined || value === "") {
      errors.push("required");
    }
  }

  if (validations.atLeastOne) {
    if (!Array.isArray(value) || value.length === 0) {
      errors.push("atLeastOne");
    }
  }

  if (validations.minLength) {
    if (value.length < validations.minLength) {
      errors.push("min");
    }
  }

  if (validations.maxLength) {
    if (value.length > validations.maxLength) {
      errors.push("max");
    }
  }

  if (validations.isEmail) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      errors.push("invalid");
    }
  }

  if (validations.isNumeric) {
    const numericRegex = /^-?\d*\.?\d+$/;
    if (!numericRegex.test(value)) {
      errors.push("numeric");
    }
  }

  if (validations.minValue) {
    if (value < validations.minValue) {
      errors.push("minValue");
    }
  }

  if (validations.maxValue) {
    if (value > validations.maxValue) {
      errors.push("maxValue");
    }
  }

  if (validations.isDate) {
    if (isNaN(new Date(value).getTime())) {
      errors.push("invalid");
    }
  }

  if (validations.array) {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        const arrayErrors = validateAttributes(item, validations.array);
        if (!arrayErrors) return;
        if (Object.keys(arrayErrors).length > 0) {
          errors.push(arrayErrors);
        }
      });
    }
  }

  return errors;
};

const validateAttributes = (attributes, validations) => {
  attributes = attributes || {};
  validations = validations || {};

  let errors = {};
  for (const [key, value] of Object.entries(attributes)) {
    const attributeValidations = validations[key] || {};
    const attributeErrors = validate(value, attributeValidations);
    if (attributeErrors.length > 0) {
      errors[key] = attributeErrors;
    }
  }

  return Object.keys(errors).length > 0 ? errors : null;
};

const errorMessage = (errors, attribiute) => {
  const error = errors ? errors[attribiute] : null;

  if (!error || error.length === 0) return null;

  let msg = `${error.map((err) => locales[err]).join(", ")}`;

  if (error.some((item) => typeof item === "object" && item !== null)) {
    msg = locales[attribiute];
  }

  return (
    <div className="flex mt-3">
      <div className="text-red-500 text-sm ml-2">{msg}</div>
    </div>
  );
};

export { validateAttributes, errorMessage };
